import React from "react"
import Layout from "../components/layout"

const DetailBlog = ({pageContext}) => {
  const { data } = pageContext
  return (
    <Layout>
      <h1>{data.frontmatter.title}</h1>
      <img src={data.frontmatter.featuredImage} style={{height: 200}}/>
      <p>{data.frontmatter.description}</p>
      <div dangerouslySetInnerHTML={{__html: data.html}}/>
    </Layout>
  )
}

export default DetailBlog